import { ApiProject } from '@api/api';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ProjectsActions = createActionGroup({
  source: 'Projects',
  events: {
    'Load Projects': emptyProps(),
    'Load Project Failed': props<{ error: string }>(),
    'Load Projects Failed': props<{ error: string }>(),
    'Projects Loaded': props<{ projects: ApiProject[] }>(),
    'Project Loaded': props<{ project: ApiProject }>(),
    'Project Accepted': emptyProps(),
    'Refresh Project': emptyProps(),
    'Set Selected Project': props<{ projectId: string }>(),
    'No Project Selected': emptyProps(),
    'Project Details Page opened': props<{ projectId: string }>(),
  },
});
